import React, { useEffect, useState } from 'react';
import { Toaster } from 'sonner';
import './admin.css';
import AdminLogin from './AdminLogin';
import AdminDashboard from './AdminDashboard';
import { adminMe, getAdminToken, setAdminToken, onUnauthorized } from './adminApi';

const AdminApp = () => {
  const [admin, setAdmin] = useState(undefined);

  useEffect(() => {
    onUnauthorized(() => { setAdminToken(''); setAdmin(null); });
    if (!getAdminToken()) { setAdmin(null); return; }
    adminMe().then(setAdmin).catch(() => { setAdminToken(''); setAdmin(null); });
  }, []);

  const logout = () => { setAdminToken(''); setAdmin(null); };

  return (
    <div className="adm-root">
      {admin === undefined && <p className="adm-empty">Caricamento…</p>}
      {admin === null && <AdminLogin onLogin={setAdmin} />}
      {admin && <AdminDashboard admin={admin} onLogout={logout} />}
      <Toaster theme="dark" position="bottom-center" richColors closeButton toastOptions={{ style: { fontFamily: 'Comfortaa, sans-serif' } }} />
    </div>
  );
};

export default AdminApp;
